import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ae9d8ed"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list" }
const _hoisted_2 = {
  key: 0,
  class: "alert alert-warning text-center",
  style: {"margin-top":"10px"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "mt-1 mb-2" }, "Rooms", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "mt-1 mb-2" }, "No items found", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-1" }, null, -1))
const _hoisted_6 = [
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "table table-hover"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "name" }, "Name"),
    /*#__PURE__*/_createElementVNode("th", { class: "category text-center" }, "Category"),
    /*#__PURE__*/_createElementVNode("th", { class: "priority text-center" }, "Priority"),
    /*#__PURE__*/_createElementVNode("th", { class: "actions" })
  ])
], -1))
const _hoisted_9 = { class: "text-center" }
const _hoisted_10 = { class: "text-center" }
const _hoisted_11 = { class: "text-center" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pencil-alt" }, null, -1))
const _hoisted_17 = [
  _hoisted_16
]

import { ref, computed, inject } from 'vue';
import { useStore } from 'vuex';
import { useToast } from "vue-toastification";
import { DictionaryRoom } from '@/models';
import DictionaryRoomModal from '@/components/modals/DictionaryRoomModal.vue';

import { Container, Draggable } from "vue-dndrop";


export default /*#__PURE__*/_defineComponent({
  __name: 'DictionaryRooms',
  setup(__props) {

const dictionaryRoomModalEdit = ref(null);

const store = useStore();
const toasted = useToast();
const actProperty: any = inject('actProperty');

const customerdictionary = computed(() => store.getters['customerdictionary/current']);
const rooms = computed(() => store.getters['customerdictionary/rooms']);

const removeFromRooms = (room: DictionaryRoom) => {
  store.commit('customerdictionary/removeFromRooms', room);
};

const setSelectedRoom = (room: DictionaryRoom) => {
  store.commit('customerdictionary/setSelectedRoom', room);
};

const setRoomList = async (rooms: DictionaryRoom[]) => {
  await store.dispatch('customerdictionary/setRoomList', rooms);
};

const edit = (room: DictionaryRoom) => {
  setSelectedRoom(room);
  const modal = dictionaryRoomModalEdit.value;
  modal.show();
}

const remove = async (room: DictionaryRoom) => {
  actProperty
    .confirmPrompt()
    .then(() => removeFromRooms(room))
    .then(() => toasted.success("Room deleted"))
    .catch((err: any) => actProperty.displayError(err));
};

const onDrop = (dragResult: any) => {
  setRoomList(applyDrag(rooms.value, dragResult));
};

const applyDrag = (rooms: DictionaryRoom[], dragResult: any) => {
  const { removedIndex, addedIndex, payload } = dragResult;
  if (removedIndex === null && addedIndex === null) return rooms;

  const result = [...rooms];
  let itemToAdd = payload;

  if (removedIndex !== null) {
    itemToAdd = result.splice(removedIndex, 1)[0];
  }

  if (addedIndex !== null) {
    result.splice(addedIndex, 0, itemToAdd);
  }

  return result;
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!customerdictionary.value.rooms.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_6))
      : (_openBlock(), _createElementBlock("table", _hoisted_7, [
          _hoisted_8,
          _createVNode(_unref(Container), {
            onDrop: onDrop,
            tag: "tbody",
            "lock-axis": "y",
            "drag-class": "opacity-ghost",
            "animation-duration": 500
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customerdictionary.value.rooms, (room) => {
                return (_openBlock(), _createBlock(_unref(Draggable), {
                  key: room.slug,
                  tag: "tr"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("td", null, _toDisplayString(room.name), 1),
                    _createElementVNode("td", _hoisted_9, _toDisplayString(room.category), 1),
                    _createElementVNode("td", _hoisted_10, _toDisplayString(room.priority), 1),
                    _createElementVNode("td", _hoisted_11, [
                      _createElementVNode("button", {
                        class: "btn btn-outline-danger",
                        onClick: [
                          ($event: any) => (remove(room)),
                          _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                        ]
                      }, _hoisted_14, 8, _hoisted_12),
                      _createElementVNode("button", {
                        class: "btn btn-outline-primary",
                        onClick: [
                          ($event: any) => (edit(room)),
                          _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
                        ]
                      }, _hoisted_17, 8, _hoisted_15)
                    ])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ])),
    _createVNode(DictionaryRoomModal, {
      id: `room-modal-edit`,
      ref_key: "dictionaryRoomModalEdit",
      ref: dictionaryRoomModalEdit,
      operation: 'edit'
    }, null, 512)
  ]))
}
}

})